import { Injectable } from '@angular/core';
import { Feature } from 'ol';
import VectorLayer from 'ol/layer/Vector';
import { Asset } from '../models/asset.model';
import GeoJSON from 'ol/format/GeoJSON';
import { MapService } from './map.service';

/**
 * Helper service for the Feature Select feature of the map.
 * It contains global variables to communicate the feature select component with other components, as well as other
 * utility function used by the feature select.
 */
@Injectable({
  providedIn: 'root'
})
export class AssetsService {

  public ASSET_PROPERTY_KEY = "asset";

  public set assetsLayer(value: VectorLayer<any>) {
    if (this._assetsLayer) { //if the layer existed, clear it and remove it from the map
      this._assetsLayer.getSource().clear();
      this._assetsLayer.setMap(null);
    }

    this._assetsLayer = value;
  }
  public get assetsLayer(): VectorLayer<any> {
    return this._assetsLayer;
  }
  _assetsLayer: VectorLayer<any> = null;

  constructor(
    private mapService: MapService
  ) { }

  buildFeatureFromAsset(asset: Asset) {
    const feature = <Feature>new GeoJSON().readFeatures(asset.geometry)[0];
    feature.set(this.ASSET_PROPERTY_KEY, asset);
    return feature;
  }

  addAssets(assets: Feature[]) {
    this.assetsLayer.getSource().addFeatures(assets);
  }

  clearAssets() {
    this.assetsLayer.getSource().clear();
  }

  removeAssets(assets: Feature[]) {
    assets.forEach(feature => {
      this.assetsLayer.getSource().removeFeature(feature);
    });
  }

  getAssetByUrn(urn: string) {

  }

  requestAssets() {
    //TODO: Call the assets from the backend
    // let apiResponse = this.mockAssetResponse().result;
    // let assetsToAdd = new GeoJSON().readFeatures(apiResponse);
    // if (apiResponse && apiResponse.crs && apiResponse.crs.properties && apiResponse.crs.properties.name) {
    //     let sourceEPSG = apiResponse.crs.properties.name;
    //     let destinationEPSG = MapService.EPSG_3857_KEY;
    //     for (let feature of assetsToAdd) {
    //         feature.getGeometry().transform(sourceEPSG, destinationEPSG);
    //     }
    // }
    // this.addAssets(assetsToAdd);
  }

  mockAssetResponse() {
    return {
      "result": {
        "features": [
          {
            "type": "Feature",
            "id": "swrefVrecordVdatasetZgisVcollectionZbuildingVkeysZ6622851107001404889",
            "properties": {
              "location_address": [
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZaddressVkeysZ4026609553449567045\",\"label\":\"VIALE DELLA REPUBBLICA 13, 11_041_041044_8000692916_13\"}"
              ],
              "ebw_scale": [
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZebw_scaleVkeysZ6622851107001404906\",\"label\":\", 2, Sconosciuto, \"}"
              ],
              "name": null,
              "construction_status": "Realizzato",
              "ebw_stato_vendibilita": "",
              "mit_bays": [

              ],
              "mobile_sheaths": [

              ],
              "point_of_interest": [
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZpoint_of_interestVkeysZ6622851107038195703\",\"label\":\"Aereo, Enel Distribuzione\"}"
              ],
              "access_points": [

              ],
              "ebw_mdu_routes": [

              ],
              "anagrafiche": [

              ],
              "type": "Residential",
              "ebw_note": null,
              //"style": "gis.uub.location_in_t03.125x80",
              "style": "gis.building.location_regular.0",
              "connections": [

              ],
              "attachments": [

              ],
              "internals": false
            },
            "geometry": {
              "type": "Point",
              "coordinates": [
                12.915647357553578,
                43.912505440869516
              ]
            }
          },

          {
            "type": "Feature",
            "id": "swrefVrecordVdatasetZgisVcollectionZunderground_routeVkeysZ6622851107040483269",
            "properties": {
              "ebw_tipo_posa": "Minitrincea",
              "underground_route_type": "Trench",
              "construction_status": "Progettato",
              "calculated_length": 23.9757421875,
              "measured_length": null,
              "ebw_proprietario": "EOF",
              "owner": null,
              "ebw_posa_dettaglio": null,
              "ebw_installer": null,
              "ebw_utilizzo": null,
              "ebw_flag_occupazione": null,
              "ebw_flag_infrastruttura_terzi": null,
              "ebw_flag_infrastruttura_enel": null,
              "mobile_stato_permesso": null,
              "progetto_of": null,
              "sheaths": [
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZsheath_with_locVkeysZ6622851107042775979\",\"label\":\"PU_01/05e2-PU_01/05e23, Microcavo 96(24)FO G657A, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZsheath_with_locVkeysZ6622851107042914526\",\"label\":\"PU_01/05e23-PU_01/05e23/PD_003, Microcavo 96(12)FO G652D, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZsheath_with_locVkeysZ6622851107042914848\",\"label\":\"PU_01/05e23-PU_01/05e23/PD_001, Microcavo 96(12)FO G652D, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZsheath_with_locVkeysZ6622851107042915265\",\"label\":\"PU_01/05e23-G479_VIALE DANTE ALIGHIERI_41_1, Microcavo 144(24)FO G652D, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZsheath_with_locVkeysZ6622851107042916170\",\"label\":\"PU_01/05e23-G479_VIALE GUGLIELMO MARCONI_42, Microcavo 24FO G652D, Progettato\"}"
              ],
              "conduits": [
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977260\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977272\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977255\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977261\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977273\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977256\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977274\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977257\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977269\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977275\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977258\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977270\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977259\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977271\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}"
              ],
              "mobile_practices": [

              ],
              "notes": null,
              "style": "gis.underground_route.route_in.3",
              "attachments": [

              ],
              "internals": true
            },
            "geometry": {
              "type": "LineString",
              "coordinates": [
                [
                  12.914396050125433,
                  43.9152548759938
                ],
                [
                  12.914616474551513,
                  43.91510935716811
                ]
              ]
            }
          },

          {
            "type": "Feature",
            "id": "swrefVrecordVdatasetZgisVcollectionZaddressVkeysZ4026609553449605620",
            "properties": {
              "ebw_indirizzo": "VIALE DANTE ALIGHIERI",
              "address_number": "62",
              "ebw_fis_naming": "11_041_041044_8000692920_62",
              "type": "Residential",
              "name": "380100101712829",
              "ebw_tipologia_uscita": "Walk-Out",
              "ebw_totale_ui": 3,
              "ebw_numero_edifici": 1,
              "progetto_of": null,
              "buildings": [
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZbuildingVkeysZ6622851107027496384\",\"label\":\", Residential, 3, Sconosciuto, \"}"
              ],
              "master": null,
              "slaves": [
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZaddressVkeysZ4026609553449513800\",\"label\":\"VIALE TRENTO 160/1, 11_041_041044_8000692901_160/1\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZaddressVkeysZ4026609553449513805\",\"label\":\"VIALE TRENTO 160, 11_041_041044_8000692901_160\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZaddressVkeysZ4026609553449513865\",\"label\":\"VIALE TRENTO 162, 11_041_041044_8000692901_162\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZaddressVkeysZ4026609553449605630\",\"label\":\"VIALE DANTE ALIGHIERI 66, 11_041_041044_8000692920_66\"}"
              ],
              "ebw_street_name": [
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZebw_street_nameVkeysZ4026609553448948158\",\"label\":\"VIALE DANTE ALIGHIERI, 8000692920\"}"
              ],
              "anagrafiche": [

              ],
              "style": "gis.address.location.1",
              //"style": "gis.uub.location_in_t03.125x80",
              "attachments": [
                "{\"data\":\"2022-10-05T07:53:42.000Z\",\"dim\":null,\"gps\":{\"latitude\":null,\"longitude\":null},\"link\":\"\\\\\\\\10.151.130.86\\\\Estrazioni_psg_PNIM\\\\app\\\\addresses\\\\1437955\\\\photos\\\\ext_1553676472.jpg\",\"name\":\"\\\\\\\\10.151.130.86\\\\Estrazioni_psg_PNIM\\\\app\\\\addresses\\\\1437955\\\\photos\\\\ext_1553676472.jpg\",\"note\":\"VIALE DANTE ALIGHIERI, 62\"}",
                "{\"data\":\"2022-10-05T07:53:42.000Z\",\"dim\":null,\"gps\":{\"latitude\":null,\"longitude\":null},\"link\":\"\\\\\\\\10.151.130.86\\\\Estrazioni_psg_PNIM\\\\app\\\\addresses\\\\1437955\\\\photos\\\\ext_1553676465.jpg\",\"name\":\"\\\\\\\\10.151.130.86\\\\Estrazioni_psg_PNIM\\\\app\\\\addresses\\\\1437955\\\\photos\\\\ext_1553676465.jpg\",\"note\":\"VIALE DANTE ALIGHIERI, 62\"}",
                "{\"data\":\"2022-10-05T07:53:42.000Z\",\"dim\":null,\"gps\":{\"latitude\":null,\"longitude\":null},\"link\":\"\\\\\\\\10.151.130.86\\\\Estrazioni_psg_PNIM\\\\app\\\\addresses\\\\1437955\\\\photos\\\\ext_1553676504.jpg\",\"name\":\"\\\\\\\\10.151.130.86\\\\Estrazioni_psg_PNIM\\\\app\\\\addresses\\\\1437955\\\\photos\\\\ext_1553676504.jpg\",\"note\":\"VIALE DANTE ALIGHIERI, 62\"}"
              ]
            },
            "geometry": {
              "type": "Point",
              "coordinates": [
                12.914977249909766,
                43.91504256769181
              ]
            }
          },

          {
            "type": "Feature",
            "id": "swrefVrecordVdatasetZgisVcollectionZuubVkeysZ6622851107040483283",
            "properties": {
              "spec_id": "125x80",
              "ebw_owner": "EOF",
              "conduits": [
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977187\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977233\",\"label\":\"MINITUBO-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977230\",\"label\":\"MINITUBO-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977247\",\"label\":\"MINITUBO-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977273\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977192\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977197\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977198\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977235\",\"label\":\"MINITUBO-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977186\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977241\",\"label\":\"MINITUBO-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977228\",\"label\":\"MINITUBO-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977256\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977238\",\"label\":\"MINITUBO-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977272\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977191\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977259\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977234\",\"label\":\"MINITUBO-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977199\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977245\",\"label\":\"MINITUBO-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977260\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977269\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977239\",\"label\":\"MINITUBO-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977190\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977243\",\"label\":\"MINITUBO-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977229\",\"label\":\"MINITUBO-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977194\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977240\",\"label\":\"MINITUBO-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977244\",\"label\":\"MINITUBO-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977227\",\"label\":\"MINITUBO-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977261\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977237\",\"label\":\"MINITUBO-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977270\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977189\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977193\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977232\",\"label\":\"MINITUBO-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977271\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977275\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977258\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977255\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977196\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977188\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977242\",\"label\":\"MINITUBO-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977246\",\"label\":\"MINITUBO-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977231\",\"label\":\"MINITUBO-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977195\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977274\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977257\",\"label\":\"MINITUBO FENDER-10/14, EOF, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZmit_conduitVkeysZ28977236\",\"label\":\"MINITUBO-10/14, EOF, Progettato\"}"
              ],
              "construction_status": "Progettato",
              "ebw_installer": null,
              "ebw_utilizzo": null,
              "ebw_data_installazione": null,
              "ebw_flag_posa_nuova": true,
              "mobile_stato_permesso": null,
              "equipments": [

              ],
              "sheaths": [
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZsheath_with_locVkeysZ6622851107042775979\",\"label\":\"PU_01/05e2-PU_01/05e23, Microcavo 96(24)FO G657A, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZsheath_with_locVkeysZ6622851107042914526\",\"label\":\"PU_01/05e23-PU_01/05e23/PD_003, Microcavo 96(12)FO G652D, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZsheath_with_locVkeysZ6622851107042914678\",\"label\":\"PU_01/05e23-PU_01/05e23/PD_002, Microcavo 96(12)FO G652D, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZsheath_with_locVkeysZ6622851107042914848\",\"label\":\"PU_01/05e23-PU_01/05e23/PD_001, Microcavo 96(12)FO G652D, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZsheath_with_locVkeysZ6622851107042915066\",\"label\":\"PU_01/05e23-G479_VIALE TRENTO_181_1, Microcavo 24FO G652D, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZsheath_with_locVkeysZ6622851107042915265\",\"label\":\"PU_01/05e23-G479_VIALE DANTE ALIGHIERI_41_1, Microcavo 144(24)FO G652D, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZsheath_with_locVkeysZ6622851107042915411\",\"label\":\"PU_01/05e23-G479_VIALE TRENTO_173/1_1, Microcavo 24FO G652D, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZsheath_with_locVkeysZ6622851107042915479\",\"label\":\"PU_01/05e23-G479_VIALE DANTE ALIGHIERI_54_1, Microcavo 24FO G652D, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZsheath_with_locVkeysZ6622851107042916084\",\"label\":\"PU_01/05e23-G479_VIALE TRENTO_173, Microcavo 24FO G652D, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZsheath_with_locVkeysZ6622851107042916170\",\"label\":\"PU_01/05e23-G479_VIALE GUGLIELMO MARCONI_42, Microcavo 24FO G652D, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZsheath_with_locVkeysZ6622851107042916300\",\"label\":\"PU_01/05e23-G479_VIALE DANTE ALIGHIERI_31, Microcavo 48FO G652D, Progettato\"}",
                "{\"urn\":\"swrefVrecordVdatasetZgisVcollectionZsheath_with_locVkeysZ6622851107042916570\",\"label\":\"PU_01/05e23-G479_VIALE DANTE ALIGHIERI_62, Microcavo 24FO G652D, Progettato\"}"
              ],
              "mobile_practices": [

              ],
              "progetto_of": null,
              "ebw_note": null,
              "style": "gis.uub.location_in_t03.125x80",
              "internals": true,
              "attachments": [

              ],
              "tag_code": [

              ]
            },
            "geometry": {
              "type": "Point",
              "coordinates": [
                12.914616474551513,
                43.91510935716811
              ]
            }
          }
        ],
        "type": "FeatureCollection",
        "bbox": [
          12.0,
          43.0,
          13.0,
          45.0
        ],
        "crs": {
          "type": "name",
          "properties": {
            "name": "EPSG:4326"
          }
        }
      }
    }
  }
}
